import React, { useEffect, useState } from "react";
import axiosInstance from "../../../Config/axios";
import { API_URLS } from "../../../Config/API_URLS";
import { useNavigate } from "react-router-dom";
import { bannerFn } from "../../../Services/Banner";
import { useMutation, useQueryClient } from "react-query";
import CustomDiv from "../../../Shared/CustomDiv";
import { Divider } from "@mui/joy";
import Text from "../../../Shared/Text";
import { useDispatch } from "react-redux";
import { enqueueSnackbar } from "notistack";
import { setThemeMode } from "../../../Redux/Actions/ThemeMode";
import { CircularProgress } from "@mui/material";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";

const HomeProduct = () => {
  const [data, setData] = useState([]);
  const [dataa, setDataa] = useState([]);
  const [dataaa, setDataaa] = useState([]);
  const [dataaaa, setDataaaa] = useState([]);
  const [banners, setBanners] = useState([]);
  const [dat1, setDat1] = useState([]);
  const [isCart, setIsCart] = useState(false);
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const handleLogin = () => {
    dispatch(setThemeMode(true));
  };
  const getCatagery = () => {
    axiosInstance
      .get(API_URLS.catagery)
      .then((response) => {
        setData(response?.data?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    getCatagery();
  }, []);
  const Products = () => {
    const reqBody = {
      add_quantity: 1,
    };
    axiosInstance.post(API_URLS.topRated, reqBody).then((response) => {
      setDataa(response.data.data.product_list);
    });
  };
  const Products1 = () => {
    const reqBody = {
      add_quantity: 1,
    };
    axiosInstance.post(API_URLS.productList, reqBody).then((response) => {
      setDat1(response.data.data.product_list);
    });
  };
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  const Productss = () => {
    const reqBody = {
      add_quantity: 1,
    };
    axiosInstance.post(API_URLS.recentlyAdded, reqBody).then((response) => {
      setDataaa(response.data.data.product_list);
    });
  };

  const Productsss = () => {
    const reqBody = {
      add_quantity: 1,
    };
    axiosInstance.post(API_URLS.mostViewed, reqBody).then((response) => {
      setDataaaa(response.data.data.product_list);
    });
  };
  const client = useQueryClient();
  const addToCart = (event, variantId) => {
    event.stopPropagation();
    const reqBody = new FormData();
    reqBody.append("product_id", variantId);
    reqBody.append("add_quantity", 1);
    setIsCart(true);
    axiosInstance
      .post(API_URLS.addToCart, reqBody)
      .then((response) => {
        client.refetchQueries(["myCartList"]);
        enqueueSnackbar(response.data.status);
        setIsCart(false);
      })
      .catch((error) => {
        enqueueSnackbar("Something went wrong..!", { variant: "error" });
      });
  };
  const { mutate: banner } = useMutation(bannerFn, {
    onSuccess: (response) => {
      setBanners(response.data.data);
    },
  });

  useEffect(() => {
    // Product();
    Products();
    Productss();
    Productsss();
    banner();
    Products1();
  }, []);

  return (
    <>
      <div className="lg:px-20 ">
        <CustomDiv className="grid grid-cols-2 flex-col-reverse lg:gap-10 gap-2 justify-center items-center my-4 bg-[#F2F8F9] p-4 ">
          {banners?.map((banner) => {
            return (
              <div className="flex flex-col gap-2 lg:gap-5">
                <Divider textAlign="left" className="font-bold lg:text-xl">
                  <Text>{banner.brand_name}</Text>
                </Divider>
                <div className="flex gap-2 lg:gap-10">
                  <img src={banner.image} alt="" />
                </div>
              </div>
            );
          })}
        </CustomDiv>
        <div className="flex justify-between lg:my-5 lg:text-3xl text-xl font-bold text-gray-700 py-5 px-8 bg-gray-200 text-center">
          <p className="">TOP RATED PRODUCTS</p>
        </div>
        <div className="grid lg:grid-cols-4 xl:grid-cols-5 md:grid-cols-2 grid-cols-2 lg:gap-2 gap-3 lg:my-0 my-5  ">
          {dataa?.map((product) => {
            return (
              <div
                className=" group-item group object-cover  h-fit  duration-200 lg:my-5 lg:-mb-5 shadow bg-white cursor-pointer"
                onClick={() =>
                  navigate(`/product/${product?.id}/${product?.variant_id}`)
                }
              >
                <span className="group ">
                  <img src={product.image} alt="" className="  object-cover" />
                  <div className="bg-white text-center object-cover  p-2 ">
                    <p className="lg:text-md text-sm font-bold whitespace-nowrap text-ellipsis ">
                      {" "}
                      {product.title}
                    </p>
                    <span className="lg:flex flex-col items-center justify-center my-2 gap-2">
                      <span className="flex lg:gap-5 justify-between">
                        <p className="lg:text-xl text-base font-semibold">
                          ₹{product?.actual_price}
                        </p>
                        <s className="text-gray-500 lg:text-base text-sm">
                          ₹{product?.price}
                        </s>
                      </span>
                      <p className="text-green-500 lg:text-base text-sm">
                        ₹{product?.discount_percent}off
                      </p>
                    </span>
                    <p
                      className={
                        product?.stock_sataus === "In-stock"
                          ? " bg-violet-50  rounded-lg"
                          : "bg-violet-50 text-red-500 rounded-lg"
                      }
                    >
                      {product?.stock_sataus}
                    </p>
                    <div className=" flex flex-col justify-center items-center  transition duration-200 p-1 px-4 rounded-md m-2   font-semibold">
                      {isCart ? (
                        <button>
                          <CircularProgress size={25} color="inherit" />
                        </button>
                      ) : (
                        <button
                          onClick={(event) =>
                            localStorage.getItem("token")
                              ? addToCart(event, product?.variant_id)
                              : handleLogin()
                          }
                          className=" lg:text-base text-sm  flex gap-5 "
                        >
                          <ShoppingCartOutlinedIcon />{" "}
                          <p className=" whitespace-nowrap mt-1">Add To Bag</p>
                        </button>
                      )}
                    </div>
                  </div>
                </span>
              </div>
            );
          })}
        </div>
        <CustomDiv className="grid grid-cols-2 flex-col-reverse lg:gap-10 gap-2 justify-center items-center my-8 bg-[#F2F8F9]  ">
          {banners?.slice(0, 2).map((banner) => {
            return (
              <div className="flex flex-col gap-2 lg:gap-5">
                <Divider textAlign="left" className="font-bold lg:text-xl">
                  <Text>{banner.brand_name}</Text>
                </Divider>
                <div className="flex gap-2 lg:gap-10">
                  <img src={banner.image} alt="" />
                </div>
              </div>
            );
          })}
        </CustomDiv>

        <div className="grid lg:grid-cols-4 xl:grid-cols-5 md:grid-cols-2 grid-cols-2 lg:gap-2 gap-3 lg:my-0 my-2">
          {dat1?.map((product) => {
            return (
              <div
                className=" group-item group object-cover  h-fit  duration-200 lg:my-5 lg:-mb-5 shadow bg-white cursor-pointer"
                onClick={() =>
                  navigate(`/product/${product?.id}/${product?.variant_id}`)
                }
              >
                <span className="group ">
                  <img src={product.image} alt="" className="  object-cover" />
                  <div className="bg-white text-center object-cover  p-2 ">
                    <p className="lg:text-md text-sm font-bold whitespace-nowrap text-ellipsis ">
                      {product.title}
                    </p>
                    <span className="lg:flex flex-col items-center justify-center my-2 gap-2">
                      <span className="flex lg:gap-5 justify-between">
                        <p className="lg:text-xl text-base font-semibold">
                          ₹{product?.actual_price}
                        </p>
                        <s className="text-gray-500 lg:text-base text-sm">
                          ₹{product?.price}
                        </s>
                      </span>
                      <p className="text-green-500 lg:text-base text-sm">
                        ₹{product?.discount_percent}off
                      </p>
                    </span>
                    <p
                      className={
                        product?.stock_sataus === "In-stock"
                          ? " bg-violet-50 rounded-lg"
                          : "bg-violet-50 text-red-500 rounded-lg"
                      }
                    >
                      {product?.stock_sataus}
                    </p>
                    <div className=" flex flex-col justify-center items-center  transition duration-200 p-1 px-4 rounded-md m-2   font-semibold">
                      {isCart ? (
                        <button>
                          <CircularProgress size={25} color="inherit" />
                        </button>
                      ) : (
                        <button
                          onClick={(event) =>
                            localStorage.getItem("token")
                              ? addToCart(event, product?.variant_id)
                              : handleLogin()
                          }
                          className=" lg:text-base text-sm  flex gap-5 "
                        >
                          <ShoppingCartOutlinedIcon />{" "}
                          <p className=" whitespace-nowrap mt-1">Add To Bag</p>
                        </button>
                      )}
                    </div>
                  </div>
                </span>
              </div>
            );
          })}
        </div>

        <CustomDiv className="grid grid-cols-2 flex-col-reverse lg:gap-10 gap-2 justify-center items-center my-4 lg:my-8 bg-[#F2F8F9] p-4">
          {banners?.slice(0, 2).map((banner) => {
            return (
              <div className="flex flex-col gap-2 lg:gap-5">
                <Divider textAlign="left" className="font-bold lg:text-xl">
                  <Text>{banner.brand_name}</Text>
                </Divider>
                <div className="flex gap-2 lg:gap-10">
                  <img className="w-full" src={banner.image} alt="" />
                </div>
              </div>
            );
          })}
        </CustomDiv>

        <div className="flex justify-between lg:text-3xl lg:mt-5 text-xl font-bold text-gray-700 py-5 px-8 bg-gray-200 text-center">
          <p className="">RECENTLY ADDED PRODUCTS</p>
        </div>

        <div className="grid lg:grid-cols-4 xl:grid-cols-5 md:grid-cols-2 grid-cols-2 lg:gap-2 gap-3 lg:my-0 my-2 ">
          {dataaa?.map((product) => {
            return (
              <div
                className=" group-item group object-cover  h-fit  duration-200 lg:my-5 lg:-mb-5 shadow bg-white cursor-pointer"
                onClick={() =>
                  navigate(`/product/${product?.id}/${product?.variant_id}`)
                }
              >
                <span className="group ">
                  <img src={product.image} alt="" className="  object-cover" />
                  <div className="bg-white text-center object-cover  p-2 ">
                    <p className="lg:text-md text-sm font-bold whitespace-nowrap text-ellipsis ">
                      {" "}
                      {product.title}
                    </p>
                    <span className="lg:flex flex-col items-center justify-center my-2 gap-2">
                      <span className="flex lg:gap-5 justify-between">
                        <p className="lg:text-xl text-base font-semibold">
                          ₹{product?.actual_price}
                        </p>
                        <s className="text-gray-500 lg:text-base text-sm">
                          ₹{product?.price}
                        </s>
                      </span>
                      <p className="text-green-500 lg:text-base text-sm">
                        ₹{product?.discount_percent}off
                      </p>
                    </span>
                    <p
                      className={
                        product?.stock_sataus === "In-stock"
                          ? " bg-violet-50 rounded-lg"
                          : "bg-violet-50 text-red-500 rounded-lg"
                      }
                    >
                      {product?.stock_sataus}
                    </p>
                    <div className=" flex flex-col justify-center items-center transition duration-200 p-1 px-4 rounded-md m-2   font-semibold">
                      {isCart ? (
                        <button>
                          <CircularProgress size={25} color="inherit" />
                        </button>
                      ) : (
                        <button
                          onClick={(event) =>
                            localStorage.getItem("token")
                              ? addToCart(event, product?.variant_id)
                              : handleLogin()
                          }
                          className=" lg:text-base text-sm  flex gap-5 "
                        >
                          <ShoppingCartOutlinedIcon />{" "}
                          <p className=" whitespace-nowrap mt-1">Add To Bag</p>
                        </button>
                      )}
                    </div>
                  </div>
                </span>
              </div>
            );
          })}
        </div>

        <CustomDiv className="grid grid-cols-2 flex-col-reverse lg:gap-10 gap-2 justify-center items-center my-8 bg-[#F2F8F9] p-4">
          {banners?.slice(2, 4).map((banner) => {
            return (
              <div className="flex flex-col gap-2 lg:gap-5">
                <Divider textAlign="left" className="font-bold lg:text-xl">
                  <Text>{banner.brand_name}</Text>
                </Divider>
                <div className="flex gap-2 lg:gap-10">
                  <img src={banner.image} alt="" />
                </div>
              </div>
            );
          })}
        </CustomDiv>

        <div className="flex justify-between lg:text-3xl lg:mt-5 text-xl font-bold text-gray-700 py-5 px-8 bg-gray-200 text-center">
          <p className="">MOST VIEWED PRODUCTS</p>
        </div>

        <div className="grid lg:grid-cols-4 xl:grid-cols-5 md:grid-cols-2 grid-cols-2 lg:gap-2 gap-3 lg:my-0 my-2 ">
          {dataaaa?.map((product) => {
            return (
              <div
                className=" group-item group object-cover  h-fit  duration-200 lg:my-5 lg:-mb-5 shadow bg-white cursor-pointer"
                onClick={() =>
                  navigate(`/product/${product?.id}/${product?.variant_id}`)
                }
              >
                <span className="group ">
                  <img src={product.image} alt="" className="  object-cover" />
                  <div className="bg-white text-center object-cover  p-2 ">
                    <p className="lg:text-md text-sm font-bold  whitespace-nowrap text-ellipsis">
                      {product.title}
                    </p>
                    <span className="lg:flex flex-col items-center justify-center my-2 gap-2">
                      <span className="flex lg:gap-5 justify-between">
                        <p className="lg:text-xl text-base font-semibold">
                          ₹{product?.actual_price}
                        </p>
                        <s className="text-gray-500 lg:text-base text-sm">
                          ₹{product?.price}
                        </s>
                      </span>
                      <p className="text-green-500 lg:text-base text-sm">
                        ₹{product?.discount_percent}off
                      </p>
                    </span>
                    <p
                      className={
                        product?.stock_sataus === "In-stock"
                          ? " bg-violet-50 rounded-lg"
                          : "bg-violet-50 text-red-500 rounded-lg"
                      }
                    >
                      {product?.stock_sataus}
                    </p>
                    <div className=" flex flex-col justify-center items-center  transition duration-200 p-1 px-4 rounded-md m-2  font-semibold">
                      {isCart ? (
                        <button>
                          <CircularProgress size={25} color="inherit" />
                        </button>
                      ) : (
                        <button
                          onClick={(event) =>
                            localStorage.getItem("token")
                              ? addToCart(event, product?.variant_id)
                              : handleLogin()
                          }
                          className=" lg:text-base text-sm  flex gap-5 "
                        >
                          <ShoppingCartOutlinedIcon />{" "}
                          <p className=" whitespace-nowrap mt-1">Add To Bag</p>
                        </button>
                      )}
                    </div>
                  </div>
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default HomeProduct;
